var map = {
	"./add-existing-registry-banner.gif": 1519,
	"./addexistingregistry_379x180_v2.jpg": 811,
	"./addexistingregistry_548x260.jpg": 1520,
	"./computer.png": 536,
	"./computer@2x.png": 1521,
	"./event.png": 302,
	"./event@2x.png": 1522,
	"./faq.png": 1523,
	"./faq@2x.png": 1524,
	"./home.png": 1525,
	"./home@2x.png": 1526,
	"./photo.png": 1527,
	"./photo@2x.png": 1528,
	"./poi.png": 1529,
	"./poi@2x.png": 1530,
	"./registry-video.jpg": 1531,
	"./registry-video@2x.jpg": 1532,
	"./registry.png": 1533,
	"./registry@2x.png": 1534,
	"./registryconversion_zolaintegration.jpg": 1535,
	"./registryconversion_zolaintegration@2x.jpg": 1536,
	"./rsvp.png": 1537,
	"./rsvp@2x.png": 1538,
	"./travel.png": 1539,
	"./travel@2x.png": 1540,
	"./wedding_party.png": 1541,
	"./wedding_party@2x.png": 1542
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1518;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1518
// module chunks = 49